<div class="notification-panel">
  <div class="notification-panel__header">
    <div class="notification-panel__header-top">
      <div>
        <h3 class="notification-panel__title">Notifications</h3>
        <p class="notification-panel__subtitle">{{ unreadCount }} unread</p>
      </div>

      <button type="button" class="bell-button" aria-label="Notifications">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M15 17H9M18 16V11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11V16L4.8 17.6C4.56672 17.911 4.50008 18.3099 4.62126 18.6783C4.74244 19.0468 5.05984 19.3344 5.43851 19.4215C9.80457 20.4262 14.1954 20.4262 18.5615 19.4215C18.9402 19.3344 19.2576 19.0468 19.3787 18.6783C19.4999 18.3099 19.4333 17.911 19.2 17.6L18 16Z"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>

        <span *ngIf="unreadCount > 0" class="bell-button__dot" aria-hidden="true"></span>
      </button>
    </div>

    <div class="notification-panel__filters">
      <div class="notification-tabs">
        <button
          type="button"
          class="notification-tab"
          [ngClass]="{ 'notification-tab--active': activeTab === 'all' }"
          (click)="setTab('all')"
        >
          All
        </button>

        <button
          type="button"
          class="notification-tab"
          [ngClass]="{ 'notification-tab--active': activeTab === 'unread' }"
          (click)="setTab('unread')"
        >
          Unread
        </button>
      </div>

      <button
        type="button"
        class="mark-all-read-btn"
        [disabled]="unreadCount === 0"
        (click)="markAllRead()"
      >
        Mark all read
      </button>
    </div>
  </div>

  <div class="notification-list">
    <ng-container *ngIf="filteredNotifications.length > 0; else emptyState">
      <div
        class="notification-card"
        *ngFor="let notification of filteredNotifications; trackBy: trackById"
        [ngClass]="{ unread: !notification.read, read: notification.read }"
      >
        <div class="notification-card__main">
          <div class="notification-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M3 4.5H5.2L7.3 14.3C7.48 15.12 8.2 15.7 9.04 15.7H17.2C18.02 15.7 18.72 15.17 18.95 14.38L20.55 8.9C20.83 7.93 20.1 6.95 19.09 6.95H8.1"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <circle cx="9.8" cy="19" r="1.2" fill="currentColor"></circle>
              <circle cx="17.2" cy="19" r="1.2" fill="currentColor"></circle>
            </svg>
          </div>

          <div class="notification-content">
            <div class="notification-heading-row">
              <h4 class="notification-title" [ngClass]="{ 'notification-title--unread': !notification.read }">
                <span *ngIf="!notification.read" class="notification-title__dot" aria-hidden="true"></span>
                {{ notification.title }}
              </h4>
              <span class="notification-time">{{ notification.date }} · {{ notification.time }}</span>
            </div>

            <p class="notification-desc">{{ notification.desc }}</p>
          </div>
        </div>

        <div class="notification-actions">
          <div>
            <button
              *ngIf="!notification.read"
              type="button"
              class="mark-read-btn"
              (click)="markAsRead(notification)"
            >
              Mark as read
            </button>

            <span *ngIf="notification.read" class="read-label">
              <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3.2 8.4L6.5 11.2L12.8 4.8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              Read
            </span>
          </div>

          <button
            type="button"
            class="delete-btn"
            aria-label="Delete notification"
            (click)="deleteNotification(notification.id)"
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M9 9.5V16.5M15 9.5V16.5M5.5 7H18.5M17 7L16.35 5.05C16.14 4.42 15.55 4 14.88 4H9.12C8.45 4 7.86 4.42 7.65 5.05L7 7M7.8 7V18.2C7.8 19.19 8.61 20 9.6 20H14.4C15.39 20 16.2 19.19 16.2 18.2V7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="notification-empty-state">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M9.5 18.2C10.2 19 11 19.5 12 19.5C13 19.5 13.8 19 14.5 18.2M18 16V11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11V16M4 4L20 20"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
        <p>No notifications here</p>
      </div>
    </ng-template>
  </div>
</div>